import PersonalReferralCard from "./PersonalReferralCard";
export default PersonalReferralCard;
